import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { useFormData } from "../../ContextData/ContextData";
import "./charts.scss";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import Footer from "../../../../../components/Footer/Footer";

export default function AllChart() {
  const { userData } = useFormData();
  const canvasRef = useRef(null);
  const [charts, setCharts] = useState({});
  const [selectedChart, setSelectedChart] = useState("D1");

  // House slots: first coordinate = house number, rest = planets
  const houseSlots = {
    1: [[10, 50], [30, 80], [30, 110]],
    2: [[110, 220], [100, 200], [110, 240], [90, 260]],
    3: [[340, 280], [310, 300], [340, 280]],
    4: [[320, 110], [340, 110], [360, 140], [370, 120]],
    5: [[190, 230], [190, 250], [190, 280]],
    6: [[290, 360], [290, 320], [290, 340]],
    7: [[20, 290], [40, 300]],
    8: [[90, 330], [100, 350], [50, 330]],
    9: [[240, 200], [270, 210], [250, 180]],
    10: [[290, 50], [290, 70], [250, 30]],
    11: [[200, 90], [200, 120], [180, 170]],
    12: [[100, 50], [80, 30], [80, 80], [60, 60]],
  };

  // Fetch API data
  useEffect(() => {
    axios
      .get("https://core-c343.onrender.com/api/varga", {
        params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              location: userData.city,
            },
      })
      .then((res) => {
        setCharts(res.data.divisionalCharts || {});
      })
      .catch((err) => {
        console.error("Error fetching divisional charts:", err);
      });
  }, []);

  // Draw chart
  useEffect(() => {
    if (!canvasRef.current || !charts[selectedChart]) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#e8811aff";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Current chart
    const currentChart = charts[selectedChart];
    const houseData = {};

    Object.keys(currentChart).forEach((planet) => {
      if (planet === "ASCENDANT") return; // skip Ascendant
      const houseNum = currentChart[planet];
      if (!houseData[houseNum]) houseData[houseNum] = [];
      houseData[houseNum].push(planet);
    });

    // Draw houses
    Object.keys(houseSlots).forEach((slot) => {
      const positions = houseSlots[slot];
      if (!positions || positions.length === 0) return;

      // 1st position → House number
      const numPos = positions[0];
      ctx.fillStyle = "orange";
      ctx.font = "12px Arial";
      ctx.fillText(slot.toString(), numPos[0], numPos[1]);

      // Remaining positions → Planets
      const planetPositions = positions.slice(1);
      const items = houseData[slot] || [];

      items.forEach((planet, idx) => {
        const pos =
          planetPositions[idx] ||
          [numPos[0] + 20 * (idx + 1), numPos[1] + 15]; // fallback offset

        ctx.fillStyle = "black";
        ctx.font = "bold 13px Arial";
        ctx.fillText(planet, pos[0], pos[1]);
      });
    });
  }, [charts, selectedChart]);

  return (
    <div className="whole-page">
        <InnerNav/>
    <div className="AllChart-container" style={{ textAlign: "center" }}>
        <h3 className="chart-heading">D1 to D16 Charts</h3>

        <div className="chart-controls">
        <label htmlFor="chartSelect" className="chart-label">Select Chart:</label>
        <select
            id="chartSelect"
            value={selectedChart}
            onChange={(e) => setSelectedChart(e.target.value)}
            className="chart-select"
        >
            {Object.keys(charts).map((chartKey) => (
            <option key={chartKey} value={chartKey}>
                {chartKey}
            </option>
            ))}
        </select>
        </div>


      <canvas
        className="canvas"
        ref={canvasRef}
        width={400}
        height={400}
        style={{ border: "1px solid black" }}
      ></canvas>
    </div>
    <Footer/>
    </div>
  );
}